export default __webpack_public_path__ + "static/media/champloo.44f213a5.PNG";